import styled from "@emotion/styled";
import { Box, DialogContent, DialogContentText, DialogTitle, IconButton, Typography } from "@mui/material";
import { StyleguideSavioColors, themeSettings } from "../../../configuration/themeSettings";
import { AppIconsClose } from "../../AppIcons";


export const StyledDialogTitle = styled(DialogTitle, {
    label: "AppBasketMenu-BasketCreateDialogTitle",
})(({ theme: Theme }) => ({
    backgroundColor: themeSettings.main.palette.primary.main,
    color: StyleguideSavioColors.white,
    textTransform: "uppercase",
    padding: "4px 9px 4px 15px",
    borderRadius: "2px",
    height: 42,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
}));

export const StyledBox = styled(Box, {
    label: "AppBasketMenu-BasketCreateDialogTitleBox",
})(({ theme: Theme }) => ({
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
}));

export const StyledTypographyTitle = styled(Typography, {
    label: "AppBasketMenu-BasketCreateDialogTitleTypography",
})(({ theme: Theme }) => ({
    display: "inline-block",
    paddingLeft: "5px",
    fontSize: 16,
   
}));
export const DialogContentStyled = styled(DialogContent, {
    label: "dialog-content-styled",
})(({ theme }) => ({
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: "10px !important",
}));

export const DialogContentTextStyled = styled(DialogContentText, {
    label: "dialog-content-text-styled",
})(({ theme }) => ({
    color: StyleguideSavioColors.black,
}));


export const AppIconsCloseStyled = styled(AppIconsClose, {
    label: "app-icons-close-styled",
})(({ theme }) => ({
    fontSize: 19,
    cursor: "pointer",
}));

export const CloseIconWrapper = styled(IconButton)(({ theme }) => ({
    cursor: "pointer",
    padding: 4,
}));
/*
const useStyles = makeStyles({
    listitem: {
        borderTop: "1px solid " + colors.lightGrey,
    },

    listTitleContainer: {
        backgroundColor: colors.lightGrey,
        display: "flex",
        flexDirection: "row",
        position: "sticky",
        width: "100%",
        top: 0,
        zIndex: 1,
    },
    listTitle: {
        //fontWeight: "bold",
        fontStyle: "italic !important",
        //lineHeight: "3.4em !important",
        marginLeft: "14px !important",
        marginTop: "14px !important",
        textTransform: "uppercase",
    },
    listTitleIcon: {
        marginLeft: "20px",
    },

    list: {
        padding: 0,
  
    },

    fabRoot: {
        minHeight: "28px",
        height: "28px",
        width: "28px",
    },
});

*/